import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { WorkProgressMaterialItem } from '../../interfaces/work-progress-material.interface';

@Component({
  selector: 'app-material-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="truncate">
      <span class="block truncate font-bold text-[10px]">{{ materialCode }}</span>
      <span class="block truncate text-xs">{{ materialName }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialCellRendererComponent implements CellRenderer<WorkProgressMaterialItem> {
  @Input() params!: CellRendererParams<WorkProgressMaterialItem>;

  get materialCode(): string {
    return this.params?.data?.materialCode || '-';
  }

  get materialName(): string {
    return this.params?.data?.materialName || '';
  }
}
